import { BaseError } from './BaseError'

/**
 * Error types that the {@link StopDelegationError} can be.
 *
 * @remarks
 * - 'NOT_DELEGATED': Listener extension is not delegated.
 */
type StopDelegationErrorType = 'NOT_DELEGATED'

/**
 * Error that the {@link DelegationController.stopDelegation} method can return.
 */
export class StopDelegationError extends BaseError {
  type: StopDelegationErrorType

  constructor(
    type: StopDelegationErrorType,
    extensionVersion: string,
    message: string = ''
  ) {
    super(message, extensionVersion)
    this.type = type

    Object.setPrototypeOf(this, StopDelegationError.prototype)
    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'StopDelegationError' })
  }
}
